export const IAppConfigId = Symbol.for('IAppConfig');

export interface IAppConfig {
    token?: string;
    delayOnProcessFailure?: number;
}
